import { render, staticRenderFns } from "./SelectObjectStore.vue?vue&type=template&id=71d45150"
import script from "./SelectObjectStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectObjectStore.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports